import Image from 'next/image';
import styled from 'styled-components';

const RichTextImage = styled.div`
  height: fit-content !important;
  width: 85% !important;
  margin: auto;
  span {
    position: relative !important;
    height: 100% !important;
    width: 100% !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export default function RichTextAsset({ id, assets }) {
  const asset = assets?.find((asset) => asset.sys.id === id);

  if (asset?.url) {
    return (
      <RichTextImage>
        <Image
          src={asset.url}
          alt={asset.description}
          layout="responsive"
          height={asset.height}
          width={asset.width}
        />
      </RichTextImage>
    );
  }

  return null;
}
